import { render, staticRenderFns } from "./UnderwriterCreate.vue?vue&type=template&id=f9a09378&"
import script from "./UnderwriterCreate.vue?vue&type=script&lang=js&"
export * from "./UnderwriterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports